import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);

export const fetchOrderStylesheet = (orderId, params) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/style_sheet/`, { params });
};
